import app from "../_app";

const combinationDeals = document.querySelector('#bundler-target-element');

if (combinationDeals) {
    document.addEventListener('bundler:loaded', function(e) {
        const html =
            '<h3 class="heading large strong pdp--heading-spacer">' + app.translationHelper("combinationsTitle") + '</h3>';

        combinationDeals.insertAdjacentHTML('beforebegin', html);
    });
}
